var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
export var droparea = __assign(__assign({}, reset), { border: '1px dashed #cccccc', boxSizing: 'border-box', cursor: 'pointer', height: '100%', padding: "".concat(64, "px ").concat(24, "px"), position: 'relative', textAlign: 'center' });
export var dragActive = {
    background: '#eaeaea',
};
export var placeholder = __assign(__assign({}, droparea), { cursor: 'default', height: '100%', minHeight: 300, padding: 16, textAlign: 'inherit' });
export var large = {
    paddingBottom: 64 * 2,
    paddingTop: 64 * 2,
};
export var embedded = {
    position: 'absolute',
    width: '100%',
};
export var placeholderContent = {
    color: '#a6a6a6',
    fontSize: 26,
    fontWeight: 300,
    left: 0,
    lineHeight: 32,
    margin: '0 auto',
    pointerEvents: 'none',
    position: 'absolute',
    right: 0,
    textAlign: 'center',
    top: '50%',
    transform: 'translateY(-50%)',
};
export var disabled = {
    cursor: 'not-allowed',
    color: '#cccccc',
};
